export const PekerjaanSurat = () => ['Tidak Bekerja', 'PNS', 'TNI/POLRI', 'BUMN', 'Pegawai Swasta/Wirausaha', 'Lain-lain']

export const PekerjaanCustom = (SelectedPekerjaan) => {
    const DefinedPekerjaan = PekerjaanSurat().find(val => val === SelectedPekerjaan)

    if (DefinedPekerjaan) {
        return DefinedPekerjaan
    } else {
        return 'Lain-lain'
    }
}